export default () => window.location.host.split('.')[0];



// WEBPACK FOOTER //
// ./src/utils/getSubdomain.js